import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-national-coffee-day',
  templateUrl: './national-coffee-day.component.html',
  styleUrls: ['./national-coffee-day.component.scss']
})
export class NationalCoffeeDayComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/national-coffee-day/national-coffee-day.component.ts